<template>
  <div class="vs-document-schedule common-consent-edu">
    <div class="schedule-heading">
      <p v-translate:pw_cohort_enroll="lang">Pick the option that best describe the participant enrolling</p>
    </div>
    <ul class="telehealth">
      <li class="cursor-pointer cohort-list" v-for="(cohort, index) in listOfCohorts" :key="index" @click="$emit('onCohortClick', cohort)">{{ cohort.cohortName }} <i class="fa fa-angle-right float-right fs-29"></i></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "cohort-list",
  props: ["isOnBackClick", "lang", "listOfCohorts"],
  data() {
    return {};
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        this.$emit("updateActiveScreen", "isActivationCodeVerified");
      }
    }
  },
  mounted() {
    this.$emit("updateHeaderNav", { showBlankHeader: true, title: " " });
    this.$root.$emit("SetAfterCancelClosedScreen", "joinIntro");
  }
};
</script>

<style>
.cohort-list {
  display: flex;
  align-items: center;
}
</style>
